export default [
  {
    title: 'Dashboard',
    icon: 'fas fa-home',
    path: '/dashboard',
    view: 'Dashboard',
    dir: 'views/',
    menu: true,
    meta: {
    }
  },

  {
    icon: 'fas fa-cogs',
    path: '/portal',
    view: 'Portal',
    title: 'Portal',
    dir: 'views/admin/portal/',
    menu: true,
    meta: {
      roles: ['MultiploAdmin.Admin', 'MultiploAdmin.TI', 'MultiploAdmin.CadastroEstruturador', 'MultiploAdmin.AdminParceiro', 'MultiploAdmin.AdminParceiroMaster']
    }
  },
  {
    icon: 'far fa-building',
    path: '/empresa',
    view: 'Empresa',
    title: 'Empresa',
    dir: 'views/admin/empresa/',
    menu: true,
    meta: {
      roles: ['MultiploAdmin.Admin', 'MultiploAdmin.TI', 'MultiploAdmin.CadastroEstruturador']
    }
  },
  {
    icon: 'fas fa-user',
    path: '/usuario',
    view: 'Usuario',
    title: 'Usuário',
    dir: 'views/admin/',
    menu: true,
    meta: {
      roles: ['MultiploAdmin.Admin', 'MultiploAdmin.TI']
    }
  },
  {
    title: 'Desenvolvimento',
    icon: 'fas fa-file-code',
    path: '/dev',
    dir: 'views/',
    menu: true,
    meta: {
      roles: ['MultiploAdmin.Admin', 'MultiploAdmin.TI']
    },
    items: [
      {
        path: '/usuariointegracao',
        view: 'UsuarioIntegracao',
        title: 'Usuário Integração',
        dir: 'admin/',
        menu: true,
        meta: {
          roles: ['MultiploAdmin.Admin', 'MultiploAdmin.TI']
        }
      },
      {
        path: '/parametro',
        view: 'Parametro',
        dir: 'admin/',
        title: 'Parâmetros',
        menu: true,
        meta: {
          roles: ['MultiploAdmin.Admin']
        }
      },
      {
        path: '/acaopermissao',
        view: 'ActionGroupAccess',
        dir: 'admin/',
        title: 'Permissões por Ação',
        menu: true,
        meta: {
          roles: ['MultiploAdmin.Admin']
        }
      },
      {
        path: '/grupopermissao',
        view: 'ActionGroupAccessByGroup',
        dir: 'admin/',
        title: 'Permissões por Grupo',
        menu: true,
        meta: {
          roles: ['MultiploAdmin.Admin']
        }
      },
      {
        path: '/projeto',
        view: 'projeto/Projeto',
        dir: 'admin/',
        title: 'Projeto',
        menu: true,
        meta: {
          roles: ['MultiploAdmin.Admin']
        }
      },
      {
        path: '/auxiliar',
        view: 'Auxiliar',
        dir: 'admin/',
        title: 'Cadastros Auxiliares',
        menu: true,
        meta: {
          roles: ['MultiploAdmin.Admin']
        }
      },
      {
        path: '/CadChecklist',
        view: 'CadChecklistPortal',
        title: 'Cadastro Checklist',
        dir: 'admin/',
        menu: true,
        meta: {
          roles: ['MultiploAdmin.Admin', 'MultiploAdmin.TI']
        }
      },
      {
        path: '/ItemCustomizado',
        view: 'ItemCustomizado',
        title: 'Cadastros Itens Customizados',
        dir: 'admin/',
        menu: true,
        meta: {
          roles: ['MultiploAdmin.Admin', 'MultiploAdmin.TI']
        }
      },
      {
        path: '/TemplateEmail',
        view: 'TemplateEmail',
        title: 'Templates de Email',
        dir: 'admin/TemplateEmail/',
        menu: true,
        meta: {
          roles: ['MultiploAdmin.Admin', 'MultiploAdmin.TI']
        }
      },
    ]
  },
  {
    title: 'Cadastro-Estruturador',
    icon: 'fas fa-file-invoice-dollar',
    path: '/cadastro-estruturador/:portal',
    dir: 'views/cadastro-estruturador/',
    menu: false,
    meta: {
      roles: ['MultiploAdmin.CadastroEstruturador']
    },
    items: [
      {
        title: 'Home',
        icon: 'fas fa-home',
        path: '/home',
        view: 'Home',
        menu: true,
        meta: {
          roles: ['MultiploAdmin.CadastroEstruturador']
        }
      },
      // {
      //   title: 'Configurações Gerais',
      //   icon: 'fas fa-solid fa-cogs',
      //   path: '/configuracoes',
      //   view: 'ConfiguracaoGeral',
      //   menu: true,
      //   meta: {
      //     roles: ['MultiploAdmin.CadastroEstruturador']
      //   }
      // },
      {
        title: 'Produtos',
        icon: 'fas fa-solid fa-layer-group',
        path: '/produtos',
        view: 'parametros/Produto',
        menu: true,
        meta: {
          roles: ['MultiploAdmin.CadastroEstruturador']
        }
      },
      {
        title: 'Produtos (Desenvolvimento)',
        icon: 'fas fa-solid fa-layer-group',
        path: '/cadastro-produtos',
        view: 'parametros/ProdutosNovo',
        menu: true,
        props: { bancodofuturo: true },
        meta: {
          roles: ['MultiploAdmin.CadastroEstruturador']
        }
      },
      {
        title: 'Valores',
        icon: 'fas fa-solid fa-percent',
        path: '/valores',
        view: 'parametros/Valor',
        menu: true,
        meta: {
          roles: ['MultiploAdmin.CadastroEstruturador']
        }
      },
      {
        title: 'Papéis',
        icon: 'fas fa-solid fa-scroll',
        path: '/papeis',
        view: 'parametros/Papel',
        menu: true,
        meta: {
          roles: ['MultiploAdmin.CadastroEstruturador']
        }
      },
      {
        title: 'Permissões Bureau',
        icon: 'mdi mdi-file-search',
        path: '/Bureau',
        view: 'parametros/Bureau',
        menu: true,
        meta: {
          roles: ['MultiploAdmin.CadastroEstruturador']
        }
      },
      {
        title: 'Desembolso',
        icon: 'fas fa-hand-holding-usd',
        path: '/Desembolso',
        view: 'parametros/Desembolso',
        menu: true,
        meta: {
          roles: ['MultiploAdmin.CadastroEstruturador']
        }
      },
      {
        title: 'Usuários',
        icon: 'fas fa-solid fa-users',
        path: '/usuarios',
        view: 'parametros/Usuario',
        menu: true,
        meta: {
          roles: ['MultiploAdmin.CadastroEstruturador']
        }
      },
      {
        title: 'Documentos',
        icon: 'fa-solid fa-folder',
        path: '/documentos',
        view: 'parametros/Documentos/Documentos',
        menu: true,
        meta: {
          roles: ['MultiploAdmin.CadastroEstruturador']
        }
      },
      {
        title: 'Vencimentos 1ª Parcela',
        icon: 'fa-solid fa-calendar',
        path: '/vencimentos-primeira-parcela',
        view: 'parametros/Vencimento',
        menu: true,
        meta: {
          roles: ['MultiploAdmin.CadastroEstruturador']
        }
      },

      // {
      //   title: 'Configurações por empresa',
      //   icon: 'fas fa-building',
      //   path: '/empresas',
      //   view: 'ConfiguracaoEmpresa',
      //   menu: true,
      //   meta: {
      //     roles: ['MultiploAdmin.CadastroEstruturador']
      //   }
      // },
    ]
  }
]
